import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { generateNewPageable, isPageTooHigh } from 'src/adminPanel/utils/helperClasses';
import { fetchCommissionEntriesByFilter, fetchCommissionStats } from 'src/api/commission-account';
import {
    fetchCommissionEntries,
    FETCH_COMMISSION_ENTRIES,
    FETCH_COMMISSION_STATS,
    requestCommissionEntries,
    requestCommissionEntriesFailure,
    requestCommissionEntriesSuccess,
    requestCommissionStats,
    requestCommissionStatsFailure,
    requestCommissionStatsSuccess,
} from './actions';

/*  Commission Account Stats  */
function* fetchCommissionStatsSaga(action: AnyAction): SagaIterator {
    yield put(requestCommissionStats());

    const { error, response } = yield call(
        fetchCommissionStats,
        action.selectedYear,
        action.compareYear,
        action.commissionType,
        action.ignoreEligibility
    );

    if (error) yield put(requestCommissionStatsFailure(error));
    else yield put(requestCommissionStatsSuccess(response));
}

export function* generateFetchCommissionStatsWatcher() {
    yield takeLatest(FETCH_COMMISSION_STATS, fetchCommissionStatsSaga);
}

/* Commission Account Entries */
function* fetchCommissionEntriesSaga(action: AnyAction): SagaIterator {
    yield put(requestCommissionEntries());

    const { error, response } = yield call(
        fetchCommissionEntriesByFilter,
        action.year,
        action.month,
        action.commissionType,
        action.ignoreEligibility,
        action.pageable
    );

    if (error) yield put(requestCommissionEntriesFailure(error));
    else {
        if (response.data !== 'notPayoutEligible' && isPageTooHigh(response.data)) {
            yield put(
                fetchCommissionEntries(
                    action.year,
                    action.month,
                    action.commissionType,
                    action.ignoreEligibility,
                    generateNewPageable(action.pageable)
                )
            );
        } else {
            yield put(requestCommissionEntriesSuccess(response));
        }
    }
}

export function* generateFetchCommissionEntriesWatcher() {
    yield takeLatest(FETCH_COMMISSION_ENTRIES, fetchCommissionEntriesSaga);
}
